import { Injectable } from "@angular/core";
import { Headers, URLSearchParams, Http } from "@angular/http";
import { environment } from "../environments/environment";
import { CookieService } from "ngx-cookie-service";

import "rxjs/add/operator/toPromise";

export class BaseService {
  private host: string;
  private basePath: string;
  private season: string;

  constructor(protected http: Http, private cookieService: CookieService) {}

  init(basePath: string) {
    this.host = environment["API_HOST"];
    this.basePath = basePath;
  }

  protected baseURL() {
    return this.host && this.host.charAt(this.host.length - 1) == "/"
      ? this.host + this.basePath
      : this.host + "/" + this.basePath;
  }

  getAuthToken() {
    let token;
    if (localStorage.getItem("token")) {
      token = "Bearer " + localStorage.getItem("token");
    } else if (this.getCookie("token")) {
      token = "Bearer " + this.getCookie("token");
    }
    return token;
  }

  list(filters?, sort?) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", this.getAuthToken());
    if (localStorage && localStorage.getItem("magic_link")) {
      filters["magic_link"] = localStorage.getItem("magic_link");
    }

    var sorts = [];
    for (var key in sort) {
      var value = sort[key];
      sorts.push("$sort[" + key + "]=" + value);
    }
    var sortString = sorts.join("&");

    var params = new URLSearchParams(sortString);
    for (var filter in filters) {
      params.append(filter, filters[filter]);
    }

    return this.http
      .get(this.baseURL(), { search: params, headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  get(id, params = null) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    if (localStorage && localStorage.getItem("magic_link")) {
      headers.append("Authorization", localStorage.getItem("magic_link"));
    }

    let url = this.baseURL() + "/" + id;
    if (params) {
      url += "?" + params;
    }
    return this.http
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  save(item) {
    if (item._id === "new") {
      return this.create(item);
    } else {
      return this.update(item);
    }
  }

  update(item) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    if (localStorage && localStorage.getItem("magic_link")) {
      headers.append("Authorization", localStorage.getItem("magic_link"));
    }
    let id = item._id ? item._id : item.id;
    delete item._id;
    return this.http
      .put(this.baseURL() + "/" + id, JSON.stringify(item), {
        headers: headers
      })
      .toPromise()
      .then(response => {
        return "ok";
      });
  }

  create(item) {
    delete item._id;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    if (localStorage && localStorage.getItem("magic_link")) {
      headers.append("Authorization", localStorage.getItem("magic_link"));
    }

    return this.http
      .post(this.baseURL(), JSON.stringify(item), { headers: headers })
      .toPromise()
      .then(response => {
        return "ok";
      });
  }

  delete(id) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    return this.http
      .delete(this.baseURL() + "/" + id, { headers: headers })
      .toPromise()
      .then(response => {
        return "ok";
      });
  }

  setCookie(key, token) {
    let secure =
      environment &&
      environment["cookie_settings"] &&
      environment["cookie_settings"].hasOwnProperty("secure")
        ? environment["cookie_settings"]["secure"]
        : true;
    localStorage.setItem(key, token);
    this.cookieService.set(key, token, 1, "/", null, secure);
  }

  getCookie(key) {
    let token = this.cookieService.get(key);
    return token ? token : null;
  }

  removeCookie(key) {
    localStorage.removeItem(key);
    this.cookieService.delete(key);
  }
}



// WEBPACK FOOTER //
// ./src/app/base.service.ts